import { render, staticRenderFns } from "./hotizontalMenChil.vue?vue&type=template&id=b2a398c2&scoped=true"
import script from "./hotizontalMenChil.vue?vue&type=script&lang=js"
export * from "./hotizontalMenChil.vue?vue&type=script&lang=js"
import style0 from "./hotizontalMenChil.vue?vue&type=style&index=0&id=b2a398c2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2a398c2",
  null
  
)

export default component.exports